
import dayjs from 'dayjs';
import 'dayjs/locale/sv.js';  // Swedish locale (if needed)
import weekOfYear from 'dayjs/plugin/weekOfYear.js';
import isBetween from 'dayjs/plugin/isBetween.js'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js'

// Set the global locale to Swedish
dayjs.locale('sv');  // or your desired locale
dayjs.extend(weekOfYear);
dayjs.extend(isBetween)
dayjs.extend(isSameOrAfter)


export default {
  install(app) {
  }
};
